export const INTEGRATION = {
  SALESFORCE: {
    value: 'salesforce',
    name: 'Salesforce',
  },
};
